module.exports = __webpack_public_path__ + "img/22.0f3026bb.png";